var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserFriendly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M502.2 907.54l20-22.06q-10.09 1.46-20.34 2.45z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#35a4dd",
    d: "M512 3.22C267.66 3.22 69.59 201.3 69.59 445.63c0 237.11 186.52 430.64 420.84 441.89l1.87 98.77q-.06.93-.06 1.89a32.62 32.62 0 0032.6 32.6h.49a32.52 32.52 0 0025.26-12.61L695 848.52c153-69.63 259.37-223.83 259.37-402.89C954.41 201.3 756.34 3.22 512 3.22z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M320 388.51c2-6 4.49-11.91 10.27-15.07 3.82-2.1 8.28-4.15 12.49-4.22 23.74-.41 47.49-.2 71.24-.2.49 0 1 .08 1.73.14V609h-70c-13.2 0-21.13-5.85-25.18-18.53a4.55 4.55 0 00-.58-1zM559.49 609h-59.62A59.8 59.8 0 01440 548.93v-126a56.87 56.87 0 0114.77-39c31.4-35.12 63-70 94.43-105.14 4.65-5.2 9.71-6.92 16.33-5 5.37 1.58 10.88 2.68 16.25 4.27 22.22 6.59 32.69 30.94 21.9 51.34-7.91 15-16.36 29.73-24.63 44.54-2.29 4.09-3 8.22-.81 12.48 2.6 5 7.07 6.63 12.47 6.61q34.31-.06 68.61 0a44.3 44.3 0 0143.6 34.2c2.26 9.16.57 18-1.4 27q-12 54.38-23.77 108.79c-4.9 22.68-26 42.44-49 45.15-7.29.86-14.7.76-22 .81-15.75.1-31.52.02-47.26.02z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFriendly);
export default ForwardRef;